<template>
  <!-- 展示组件 实时成交信息 -->
  <div>
    <div class="content">
      <div class="allData">
        <ul v-for="(item, id) in listData" :key="`trans_${id + startIndex}`" :class="{selected: id + startIndex === currentIndex }" @click="transViewClick(id)">
          <li>{{ item.dates }}</li>
          <li
            :class="
              Number(item.prices) > Number(selectItem.clearPrice)
                ? 'sellDirection'
                : Number(item.prices) < Number(selectItem.clearPrice)
                  ? 'buyDirection'
                  : ''
            "
          >
            {{ Number(item.prices).toFixed(selectItem.coinDigitalNum) }}
          </li>
          <li
            :class="
              setStrClass(
                item.upDown,
                '买入',
                'sellDirection',
                'buyDirection'
              )
            "
          >
            {{ Number(item.volumn).toFixed(selectItem.quantityNum) }}
            {{ item.upDown === '买入' ? '↑' : '↓' }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    // 实时行情数据数组
    listData: {
      type: Array,
      required: false,
      default: () => []
    },
    // 标注开始位置下标
    startIndex: {
      type: Number,
      required: false,
      default: 1
    },
    // 标注选中位置下标
    currentIndex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['item', 'marketDetails', 'commodityStrategyGetter']),
    data() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    selectItem() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        for (let index = 0; index < this.$store.state.hqData.marketDetails.length; index++) {
          const element = this.$store.state.hqData.marketDetails[index]
          if (this.$store.state.hqData.item.symbolId == element.symbolId) {
            return element
          }
        }
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0]
        } else {
          return {
            close: 0.00,
            quotechangeColor: 'white',
            quotechange: 0.00,
            high: 0,
            low: 0,
            amount: 0,
            symbolId: '--',
            clearPrice: 0,
            numStr: /^(\d+)\.(\d{0,2}).*$/,
            coinDigitalNum: 2,
            quantityNum: 2 // 数量
          }
        }
      }
      return {}
    },
    ceshiXh: function() {
      const itemHx = this.item.symbolId
      if (itemHx) {
        return itemHx
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    unit() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[1]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[1]
        } else {
          return '--'
        }
      }
    },
    units() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[0]

        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[0]
        } else {
          return '--'
        }
      }
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    transViewClick(id) {
      this.$emit('transViewClick', id + this.startIndex)
    }
  }
}
</script>
<style scoped lang="scss">
.allData {
  // padding: 0 0.83vw;
  // background: #000;
  height: 840px;
  display: flex;
  flex-direction: column;
  .selected{
    background: rgb(98, 76, 224);
  }
  ul {
    margin-bottom: 2px;
    // height: 21.025px;
    // line-height: 22px;
    width: 100%;
    display: flex;
    li {
      flex: 1;
      color: #fff;
      float: left;
      font-size: 14px;
      text-align: center;
    }
  }
  .sellDirection {
    color: #d74e5a !important;
  }
  .buyDirection {
    color: #41b37d !important;
  }
}
</style>
